(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('poFinishProdList', {
        templateUrl: 'views/components/views/poFinishProdList/poFinishProdList.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'poFinishProdListService', 'poFinishProdCompListAccService', 'poFinishCompListService', function ($stateParams, stateService, utilityService, poFinishProdListService, poFinishProdCompListAccService, poFinishCompListService) {

            // #region VARIABLES & DEFINITIONS
            
            const vm = this;
            let p2PoFinishKeyno = $stateParams.p2_pofinish_keyno;

            vm.model = {
                barcodeButtons: [
                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.setting.barcode = '' },
                    { id: 'search', icon: 'fas fa-search', color: 'success', type: 'success', onClick: () => searchProductionOrder() }
                ],
                setting: {
                    barcode: ''
                },
                itemsListFinishedProducts: [],
                scanning: false,
                lockedFinish: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region PROCEDURE CALLS
            
            async function loadSetting() {
                vm.model.setting = (await poFinishProdCompListAccService.getStatus({ p2_pofinish_keyno: p2PoFinishKeyno }))[0];
            }

            async function loadFinishedProducts() {
                vm.model.itemsListFinishedProducts = await poFinishProdListService.listFinishedProducts({ p2_pofinish_keyno: p2PoFinishKeyno });
            }

            async function searchProductionOrder() {
                if (utilityService.validateParmsValue(vm.model.setting.barcode) !== true) return;

                vm.model.scanning = true;

                poFinishProdListService.scanItem({
                    p2_pofinish_keyno: p2PoFinishKeyno,
                    barcode: vm.model.setting.barcode
                }).then(function () {
                    vm.model.scanning = false;

                    if (vm.model.setting.barcode > '' && vm.model.scanning === false) {
                        vm.model.setting.barcode = '';
                    }

                    loadFinishedProducts();
                });
            }

            // #endregion PROCEDURE CALLS

            // #region SCAN FIELD AND BUTTON FUNCTION
            
            vm.scanProductionOrder = function () {
                searchProductionOrder();
            }

            // #endregion SCAN FIELD AND BUTTON FUNCTION

            // #region PRODUCTION ORDER SAVE BUTTON
            
            vm.finishChanges = function () {
                vm.model.lockedFinish = true;

                poFinishCompListService.finishProductionOrder({
                    finishfromkey: 'p2_pofinish_keyno',
                    keyvalue: p2PoFinishKeyno,
                    from_webpagename: stateService.getCurrentName(),
                    from_parms: p2PoFinishKeyno
                }).then(function (response) {
                    vm.model.lockedFinish = false;

                    if (response[0]) {
                        if (response[0].webpagename === 'pofinishprodpack') {
                            stateService.go(response[0].webpagename, {
                                poh_keyno_top: response[0].webpage_parms.replace('/', ''),
                                counter: 0
                            });
                        } else if (response[0].webpagename === 'createcase') {
                            stateService.go(response[0].webpagename, response[0].webpage_parms);
                        } else {
                            stateService.back('/' + response[0].webpagename + '/' + response[0].webpage_parms);
                        }
                    }
                });
            }

            // #endregion PRODUCTION ORDER SAVE BUTTON

            // #region ABORT BUTTON FUNCTION
            
            vm.abortTask = function () {
                vm.model.lockedAbort = true;

                poFinishProdListService.abortPoFinish({ p2_pofinish_keyno: p2PoFinishKeyno }).then(function (response) {
                    vm.model.lockedAbort = false;
                    
                    stateService.back('/' + response[0].webpagename + '/' + response[0].webpage_parms);
                }, vm.model.lockedAbort = false);
            }
            
            // #endregion ABORT BUTTON FUNCTION

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                loadSetting();
                loadFinishedProducts();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
